export const CANARY_SCOPED_THEME_PROVIDER = "canary_scoped_theme_provider";
